import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import {
  FormModal,
  Input,
  Button,
  FormModalTitle,
  FormModalContent,
  FormModalActions,
  ConfirmModal,
  Typography,
} from 'sputnik-ui'
import { useFormik } from 'formik'
import * as yup from 'yup'
import { useDispatch } from 'react-redux'
import { addThirdPartyCamera } from 'features/Cameras/camerasSlice'
import { exportDevicesReport } from 'features/Devices/devicesSlice'
import { unwrapResult } from '@reduxjs/toolkit'
import config from 'config'

import { Box, Link } from '@material-ui/core'
import { useTranslation } from 'react-i18next'

const validationSchema = yup.object().shape({
  email: yup.string().email().required(),
})

// based on ExportDeviceModal. TODO refactor for it to use this component
export default function SendReport({
  open,
  handleClose,
  defaultEmail,
  operation,
  Body,
  ModalTitle,
  emailLabel,
  ...props
}) {
  const dispatch = useDispatch()

  const formik = useFormik({
    validationSchema,
    initialValues: {
      email: defaultEmail,
    },
    onSubmit: (values) => {
      dispatch(operation(values.email))
      handleClose()
    },
  })

  const { t } = useTranslation(['common', 'device'])

  return (
    <>
      <FormModal open={open} {...props}>
        <form onSubmit={formik.handleSubmit}>
          {ModalTitle ? (
            <ModalTitle />
          ) : (
            <FormModalTitle>{t('devices:export.title')}</FormModalTitle>
          )}
          {Body && <Body />}
          <FormModalContent label={emailLabel || t('devices:export.info')}>
            <Input
              required
              name="email"
              value={formik.values.email}
              label={t('common:email')}
              onChange={formik.handleChange}
              error={formik.errors && formik.errors.email}
              fullWidth
            />
          </FormModalContent>
          <FormModalActions>
            <Button
              variant="v2"
              primary
              fullWidth
              type="submit"
              disabled={!(formik.values.email && !formik.errors.email)}
            >
              {t('devices:export.download')}
            </Button>
            <Button fullWidth variant="v2" tertiary onClick={handleClose}>
              {t('common:button.back')}
            </Button>
          </FormModalActions>
        </form>
      </FormModal>
    </>
  )
}
